export default "../css/994ce505c6dd68a899c938cd492311b1.ttf";